var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// components/skeleton/common/src/animation-type.ts
var SkeletonAnimationType = /* @__PURE__ */ ((SkeletonAnimationType2) => {
  SkeletonAnimationType2["Wave"] = "wave";
  SkeletonAnimationType2["Pulse"] = "pulse";
  SkeletonAnimationType2["None"] = "none";
  return SkeletonAnimationType2;
})(SkeletonAnimationType || {});

// components/skeleton/common/src/skeleton-text-props.ts
var defaultSkeletonTextProps = {
  typography: "body02",
  width: "100%",
  lines: 1,
  animation: "wave" /* Wave */,
  disableAriaLabel: false,
  "aria-label": "Content is loading"
};

// components/skeleton/common/src/skeleton-text-style-sheet.ts
import { createComponentClassDefinitions } from "@gs-ux-uitoolkit-common/theme";
import { StyleSheet } from "@gs-ux-uitoolkit-common/style";

// components/skeleton/common/src/animation-mixin.ts
import { getEmotionInstance } from "@gs-ux-uitoolkit-common/style";
var waveAnimation = () => getEmotionInstance().keyframes`
    0% {
        background-position: -100vw;
    }
    100% {
        background-position: 100vw;
    }
`;
var pulseAnimation = (theme) => getEmotionInstance().keyframes`
    0% {
        background-color: ${theme.surface.secondary};
    }
    50% {
        background-color: ${theme.surface.tertiary};
    }
    100% {
        background-color: ${theme.surface.secondary};
    }
`;
var applyAnimationMixin = (animation, theme) => {
  switch (animation) {
    case "wave" /* Wave */:
      return {
        background: `linear-gradient(
                    90deg,
                    ${theme.surface.secondary} 0vw,
                    ${theme.surface.tertiary} 50vw,
                    ${theme.surface.secondary} 100vw
                )`,
        backgroundSize: "100vw",
        animation: `${waveAnimation()} 3s linear infinite`
      };
    case "pulse" /* Pulse */:
      return {
        animation: `${pulseAnimation(theme)} 3s ease infinite`
      };
    default:
      return {};
  }
};

// components/skeleton/common/src/skeleton-text-style-sheet.ts
var scalingFactor = 0.75;
var skeletonTextStyleSheet = new StyleSheet(
  "skeletonText",
  (props) => {
    var _a;
    return createComponentClassDefinitions(props, createDefaultStyledClasses, (_a = props.theme.styleOverrides) == null ? void 0 : _a.skeletonText);
  }
);
function createDefaultStyledClasses({
  theme,
  typography = defaultSkeletonTextProps.typography,
  animation = defaultSkeletonTextProps.animation
}) {
  return {
    root: {},
    text: {
      display: "flex",
      alignItems: "center",
      // Use the line-height of the given typography variant as the height
      height: theme.typography[typography].lineHeight,
      "&:after": __spreadValues({
        backgroundColor: theme.surface.tertiary,
        content: '""',
        width: "100%",
        // Use the font-size as the height of the :after element
        height: theme.typography[typography].fontSize,
        transform: `scaleY(${scalingFactor})`
      }, applyAnimationMixin(animation, theme))
    }
  };
}

// components/skeleton/common/src/skeleton-table-props.ts
var defaultSkeletonTableProps = {
  rows: 3,
  columns: 3,
  width: "100%",
  animation: "wave" /* Wave */,
  "aria-label": "Table content is loading"
};

// components/skeleton/common/src/skeleton-table-style-sheet.ts
import { StyleSheet as StyleSheet2 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions2 } from "@gs-ux-uitoolkit-common/theme";
var skeletonTableStyleSheet = new StyleSheet2(
  "skeletonTable",
  (props) => {
    var _a;
    return createComponentClassDefinitions2(props, createDefaultStyledClasses2, (_a = props.theme.styleOverrides) == null ? void 0 : _a.skeletonTable);
  }
);
function createDefaultStyledClasses2({
  theme,
  columns = defaultSkeletonTableProps.columns
}) {
  return {
    root: {},
    grid: {
      display: "grid",
      gridTemplateColumns: Array(columns + 1).join(" auto "),
      gridRowGap: "16px"
    },
    header: {
      borderBottom: `1px solid ${theme.border.minimal}`
    },
    cell: {
      margin: "4px 0 4px"
    }
  };
}

// components/skeleton/common/src/skeleton-area-props.ts
var defaultSkeletonAreaProps = {
  height: "80px",
  width: "100%",
  animation: "wave" /* Wave */,
  "aria-label": "Content is loading"
};

// components/skeleton/common/src/skeleton-area-style-sheet.ts
import { StyleSheet as StyleSheet3 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions3 } from "@gs-ux-uitoolkit-common/theme";
var skeletonAreaStyleSheet = new StyleSheet3(
  "skeleton-area",
  (props) => {
    var _a;
    return createComponentClassDefinitions3(props, createDefaultStyledClasses3, (_a = props.theme.styleOverrides) == null ? void 0 : _a.skeletonArea);
  }
);
function createDefaultStyledClasses3({
  theme,
  width = defaultSkeletonAreaProps.width,
  height = defaultSkeletonAreaProps.height,
  animation = defaultSkeletonAreaProps.animation
}) {
  return {
    root: __spreadValues({
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
      width,
      height,
      backgroundColor: theme.surface.tertiary
    }, applyAnimationMixin(animation, theme)),
    icon: {
      position: "absolute",
      fontSize: "8rem",
      color: theme.surface.primary
    }
  };
}

// components/skeleton/common/src/skeleton-item-props.ts
var defaultSkeletonItemProps = {
  size: "md",
  shape: "square",
  width: "80px",
  animation: "wave" /* Wave */,
  disableAriaLabel: false,
  "aria-label": "Content is loading"
};

// components/skeleton/common/src/skeleton-item-style-sheet.ts
import { StyleSheet as StyleSheet4 } from "@gs-ux-uitoolkit-common/style";
import { createComponentClassDefinitions as createComponentClassDefinitions4 } from "@gs-ux-uitoolkit-common/theme";
var skeletonSizeVariants = {
  xs: 16,
  sm: 24,
  md: 32,
  lg: 40,
  xl: 48
};
var skeletonItemStyleSheet = new StyleSheet4(
  "skeletonItem",
  (props) => {
    var _a;
    return createComponentClassDefinitions4(props, createDefaultStyledClasses4, (_a = props.theme.styleOverrides) == null ? void 0 : _a.skeletonItem);
  }
);
function createDefaultStyledClasses4({
  theme,
  size = defaultSkeletonItemProps.size,
  shape = defaultSkeletonItemProps.shape,
  width = defaultSkeletonItemProps.width,
  animation = defaultSkeletonItemProps.animation
}) {
  return {
    root: __spreadValues({
      display: "inline-block",
      backgroundColor: theme.surface.secondary,
      height: `${skeletonSizeVariants[size]}px`,
      width: shape === "circle" ? `${skeletonSizeVariants[size]}px` : width,
      borderRadius: ["circle", "rounded"].includes(shape) ? `${skeletonSizeVariants[size] / 2}px` : "0"
    }, applyAnimationMixin(animation, theme))
  };
}

// components/skeleton/common/src/skeleton-util.ts
import { cx } from "@gs-ux-uitoolkit-common/style";
var globalSkeletonTextClassName = "gs-skeleton-text";
var globalSkeletonTableClassName = "gs-skeleton-table";
var globalSkeletonAreaClassName = "gs-skeleton-area";
var globalSkeletonItemClassName = "gs-skeleton-item";
var getSkeletonTextRootClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    globalSkeletonTextClassName
  );
};
var getSkeletonTextClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.text,
    overrideClasses && overrideClasses.text,
    `${globalSkeletonTextClassName}__text`
  );
};
var getSkeletonTableRootClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    globalSkeletonTableClassName
  );
};
var getSkeletonTableGridClasses = (props) => {
  const { cssClasses } = props;
  return cx(cssClasses.grid, `${globalSkeletonTableClassName}__grid`);
};
var getSkeletonTableHeaderClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.header,
    cssClasses.grid,
    overrideClasses && overrideClasses.header,
    `${globalSkeletonTableClassName}__header`
  );
};
var getSkeletonTableCellClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.cell,
    overrideClasses && overrideClasses.cell,
    `${globalSkeletonTableClassName}__cell`
  );
};
var getSkeletonAreaRootClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    globalSkeletonAreaClassName
  );
};
var getSkeletonAreaIconClasses = (props) => {
  const { cssClasses, overrideClasses } = props;
  return cx(
    cssClasses.icon,
    overrideClasses && overrideClasses.icon,
    `${globalSkeletonAreaClassName}__icon`
  );
};
var getSkeletonItemRootClasses = (props) => {
  const { cssClasses, className, overrideClasses } = props;
  return cx(
    cssClasses.root,
    className,
    overrideClasses && overrideClasses.root,
    globalSkeletonItemClassName
  );
};
export {
  SkeletonAnimationType,
  defaultSkeletonAreaProps,
  defaultSkeletonItemProps,
  defaultSkeletonTableProps,
  defaultSkeletonTextProps,
  getSkeletonAreaIconClasses,
  getSkeletonAreaRootClasses,
  getSkeletonItemRootClasses,
  getSkeletonTableCellClasses,
  getSkeletonTableGridClasses,
  getSkeletonTableHeaderClasses,
  getSkeletonTableRootClasses,
  getSkeletonTextClasses,
  getSkeletonTextRootClasses,
  skeletonAreaStyleSheet,
  skeletonItemStyleSheet,
  skeletonSizeVariants,
  skeletonTableStyleSheet,
  skeletonTextStyleSheet
};
//# sourceMappingURL=index.mjs.map
